var E = (s, t, n) => new Promise((a, d) => {
  var m = (l) => {
    try {
      b(n.next(l));
    } catch (k) {
      d(k);
    }
  }, h = (l) => {
    try {
      b(n.throw(l));
    } catch (k) {
      d(k);
    }
  }, b = (l) => l.done ? a(l.value) : Promise.resolve(l.value).then(m, h);
  b((n = n.apply(s, t)).next());
});
import { A as Z } from "./Account-0t2lnPtO.js";
import { _ as ee } from "./AccountLogin-ad3Nqh2P.js";
import { A as te } from "./Address-QnUa_uo4.js";
import { C as oe } from "./Categories-D_jkW8RW.js";
import { r as re, u as L, a as G, o as W, b as z, c as u, e as p, f as C, g as _, t as g, h as O, w as A, i as U, j as se, k as w, s as ae, l as ie, m as x, F as $, n as ne, p as le, d as e } from "./define-element-XpjsV6s1.js";
import { u as ce } from "./useMutation-DFzOBEuf.js";
import { B as T } from "./Button-D5lKR5Sd.js";
import { _ as I } from "./_plugin-vue_export-helper-CHgC5LLL.js";
import { O as ue } from "./Offering-B0GPMhC_.js";
import { G as fe } from "./GiftCardCheckout-CqOLMwVL.js";
import { _ as pe } from "./Appointment-DVe4h1Zu.js";
import { C as de } from "./Cart-DB72546L.js";
import { C as me } from "./CartCount-CbO3KnrG.js";
import { C as H } from "./Checkout-C0cc0LET.js";
import { C as he } from "./CheckoutPayment-DikiEx66.js";
import { _ as ye } from "./ClubButton-C7vNYG5e.js";
import { C as be } from "./Clubs-BkR7ZMY8.js";
import { _ as Se } from "./ContinueToCheckout-B-L6laZs.js";
import { J as ge } from "./JoinList-cSwuZjzt.js";
import { L as ke } from "./LoginForm-D68uOH8H.js";
import { P as _e } from "./Phone-BBsTgKL1.js";
import { _ as ve } from "./ProductBuyButton-DgGwywpA.js";
import { P as Ce } from "./ProductDetails-Bu0NOA78.js";
import { P as Ue } from "./ProductList-3BayW812.js";
import { P as Fe } from "./ProductListSearch-DORTbUXC.js";
import { P as Pe } from "./ProductListSort-BhhJ-z0-.js";
import { P as Le } from "./ProductListOptions-DxBw8aNM.js";
import { o as we } from "./index-D_t0kTBY.js";
import { u as Ee } from "./use-product-y102e61c.js";
import { S as xe } from "./SideCart-B1JKAEcP.js";
import { S as Oe } from "./StripePaymentForm-CDVtd19T.js";
import { S as Ae } from "./SubscribeForm-Vs3c33Y1.js";
import { W as $e } from "./Welcome-CN5Y2iAd.js";
function Te() {
  return { submitMutation: ce({
    mutationFn: (m) => E(null, [m], function* ({
      subject: t,
      fields: n,
      template: a,
      _gotcha: d
    }) {
      const h = yield re("form/submit", {
        method: "POST",
        // Form submission doesn't need cart/session context.
        skipSessionId: !0,
        body: JSON.stringify({ subject: t, fields: n, template: a, _gotcha: d })
      });
      if (h.error)
        throw new Error(h.error);
      return h;
    })
  }) };
}
const Be = {
  ref: "container",
  class: "offset-form"
}, Me = {
  key: 0,
  class: "offset-form-success"
}, Ne = { class: "success" }, Re = {
  ref: "gotcha",
  type: "text",
  name: "_gotcha",
  autocomplete: "off",
  tabindex: "-1",
  "aria-hidden": "true",
  class: "offset-form-honeypot"
}, je = {
  key: 0,
  class: "error"
}, qe = {
  __name: "Form",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    subject: {
      type: String,
      default: ""
    },
    // Selects which email template the sdk's Email API call renders (see
    // packages/sdk/src/api/routes/form.ts) — "blank" (the default) just
    // echoes the rendered fields as-is; an account with its own dedicated
    // template can pass its name here instead.
    template: {
      type: String,
      default: "blank"
    },
    submitLabel: {
      type: String,
      default: "Submit"
    },
    submittingLabel: {
      type: String,
      default: "Sending..."
    },
    successMessage: {
      type: String,
      default: "Thanks — we'll be in touch."
    },
    // Label for the button shown alongside successMessage once submitted —
    // clicking it brings the (now-cleared) form back for another submission.
    submitAnotherLabel: {
      type: String,
      default: "Send Another Message"
    }
  },
  setup(s) {
    const t = s, { submitMutation: n } = Te(), { mutateAsync: a, isPending: d, isError: m, error: h, isSuccess: b, reset: l } = n, k = L("form"), i = L("container"), y = L("gotcha");
    function f(c) {
      if (!c) return {};
      const o = {};
      for (const r of c.querySelectorAll("[name]")) {
        const S = r.getAttribute("name");
        S && (r.type === "checkbox" ? r.checked && (o[S] = r.value === "on" ? !0 : r.value) : r.type === "radio" ? r.checked && (o[S] = r.value) : r.tagName === "SELECT" && r.multiple ? o[S] = Array.from(r.selectedOptions).map((P) => P.value) : o[S] = r.value);
      }
      return o;
    }
    function F(c) {
      if (!c) return !0;
      for (const o of c.querySelectorAll("[name][required]"))
        if (!o.checkValidity())
          return o.reportValidity(), !1;
      return !0;
    }
    function K(c) {
      if (c)
        for (const o of c.querySelectorAll("[name]"))
          if (o.type === "checkbox" || o.type === "radio")
            o.checked = o.defaultChecked;
          else if (o.tagName === "SELECT")
            for (const r of o.options)
              r.selected = r.defaultSelected;
          else
            o.value = o.defaultValue;
    }
    function X() {
      l();
    }
    const v = G(!1);
    function Y(c) {
      return E(this, null, function* () {
        var r, S, P;
        if (c.preventDefault(), v.value) return;
        const o = (S = (r = k.value) == null ? void 0 : r.getRootNode()) == null ? void 0 : S.host;
        if (F(o)) {
          v.value = !0;
          try {
            yield a({
              subject: t.subject,
              fields: f(o),
              template: t.template,
              _gotcha: ((P = y.value) == null ? void 0 : P.value) || ""
            }), K(o);
          } catch (Xe) {
          } finally {
            v.value = !1;
          }
        }
      });
    }
    return W(() => {
      z(i.value, t.inheritStyle);
    }), (c, o) => {
      var r;
      return u(), p("div", Be, [
        C(b) ? (u(), p("div", Me, [
          _("p", Ne, g(s.successMessage), 1),
          O(T, {
            type: "button",
            onClick: X
          }, {
            default: A(() => [
              U(g(s.submitAnotherLabel), 1)
            ]),
            _: 1
          })
        ])) : (u(), p("form", {
          key: 1,
          ref: "form",
          onSubmit: Y
        }, [
          _("input", Re, null, 512),
          se(c.$slots, "default", {}, void 0, !0),
          C(m) ? (u(), p("em", je, g((r = C(h)) == null ? void 0 : r.message), 1)) : w("", !0),
          O(T, {
            type: "submit",
            disabled: C(d) || v.value
          }, {
            default: A(() => [
              U(g(C(d) || v.value ? s.submittingLabel : s.submitLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ], 544))
      ], 512);
    };
  }
}, Ve = /* @__PURE__ */ I(qe, [["__scopeId", "data-v-d5990da4"]]), Qe = {
  __name: "CartType",
  props: {
    type: {
      type: String,
      default: "cart"
      // "cart" | "offering" | "event"
    }
  },
  setup(s) {
    return ae(s.type), (n, a) => null;
  }
};
var B, M, N, R, j, q, V, Q, D, J;
const De = {
  __name: "EventCheckout",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    cartUrl: {
      type: String,
      default: (M = (B = window.OFFSET) == null ? void 0 : B.cartUrl) != null ? M : "/cart"
    },
    checkoutUrl: {
      type: String,
      default: (R = (N = window.OFFSET) == null ? void 0 : N.checkoutUrl) != null ? R : "/checkout"
    },
    shopUrl: {
      type: String,
      default: (q = (j = window.OFFSET) == null ? void 0 : j.shopUrl) != null ? q : "/"
    },
    termsUrl: {
      type: String,
      default: (Q = (V = window.OFFSET) == null ? void 0 : V.termsUrl) != null ? Q : "/terms"
    },
    privacyUrl: {
      type: String,
      default: (J = (D = window.OFFSET) == null ? void 0 : D.privacyUrl) != null ? J : "/privacy"
    },
    disableExpressCheckout: {
      type: Boolean,
      default: !1
    },
    referralQuestionPlacement: {
      type: String,
      default: "receipt"
      // "receipt" | "signup"
    },
    referralOptions: {
      type: [Array, String],
      default: void 0
    }
  },
  setup(s) {
    const t = s;
    return (n, a) => (u(), ie(H, {
      inheritStyle: t.inheritStyle,
      cartUrl: t.cartUrl,
      checkoutUrl: t.checkoutUrl,
      shopUrl: t.shopUrl,
      termsUrl: t.termsUrl,
      privacyUrl: t.privacyUrl,
      disableExpressCheckout: t.disableExpressCheckout,
      referralQuestionPlacement: t.referralQuestionPlacement,
      referralOptions: t.referralOptions,
      shippingExempt: !0
    }, null, 8, ["inheritStyle", "cartUrl", "checkoutUrl", "shopUrl", "termsUrl", "privacyUrl", "disableExpressCheckout", "referralQuestionPlacement", "referralOptions"]));
  }
}, Je = {
  class: "offset-product-list-filter",
  ref: "container"
}, Ge = ["disabled", "aria-expanded", "aria-controls"], We = ["id"], ze = {
  key: 0,
  class: "offset-product-list-filter-empty"
}, Ie = ["checked", "onChange"], He = {
  __name: "ProductListFilter",
  props: {
    property: {
      type: String,
      required: !0
    },
    // Defaults to the matching DEFAULT_OPTIONS entry's own label (e.g.
    // "Vintage") when not given.
    label: {
      type: String,
      default: ""
    },
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(s) {
    const t = s, { options: n } = Ee(), a = G(!1), d = L("container"), m = x(() => n.value.find((i) => i.key === t.property)), h = x(() => {
      var i;
      return t.label || ((i = m.value) == null ? void 0 : i.label) || t.property;
    }), b = x(() => {
      var i, y, f;
      return (f = (y = (i = m.value) == null ? void 0 : i.options) == null ? void 0 : y.filter((F) => F.checked)) != null ? f : [];
    });
    function l() {
      return "product-list-filter-" + t.property;
    }
    function k(i) {
      i.checked = !i.checked;
    }
    return we(d, () => a.value = !1), W(() => {
      z(d.value, t.inheritStyle);
    }), (i, y) => (u(), p("div", Je, [
      _("button", {
        type: "button",
        class: "offset-product-list-filter-toggle",
        disabled: !m.value,
        "aria-haspopup": "true",
        "aria-expanded": a.value,
        "aria-controls": l(),
        onClick: y[0] || (y[0] = (f) => a.value = !a.value)
      }, [
        _("span", null, [
          U(g(h.value), 1),
          b.value.length ? (u(), p($, { key: 0 }, [
            U(" (" + g(b.value.length) + ")", 1)
          ], 64)) : w("", !0)
        ]),
        (u(), p("svg", {
          class: ne(["offset-product-list-filter-chevron", { "is-open": a.value }]),
          viewBox: "0 0 10 6",
          "aria-hidden": "true"
        }, y[1] || (y[1] = [
          _("path", {
            d: "M1 1L5 5L9 1",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "1.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1)
        ]), 2))
      ], 8, Ge),
      a.value && m.value ? (u(), p("div", {
        key: 0,
        id: l(),
        class: "offset-product-list-filter-panel"
      }, [
        m.value.options.length ? w("", !0) : (u(), p("div", ze, "No options available")),
        (u(!0), p($, null, le(m.value.options, (f) => (u(), p("label", {
          key: f.label,
          class: "offset-product-list-filter-item"
        }, [
          _("input", {
            type: "checkbox",
            checked: f.checked,
            onChange: (F) => k(f)
          }, null, 40, Ie),
          U(" " + g(f.label) + " (" + g(f.count) + ") ", 1)
        ]))), 128))
      ], 8, We)) : w("", !0)
    ], 512));
  }
}, Ke = /* @__PURE__ */ I(He, [["__scopeId", "data-v-88499c28"]]);
function At() {
  e("offset-account", Z), e("offset-categories", oe), e("offset-form", Ve), e("offset-offering", ue), e("offset-gift-card-checkout", fe), e("offset-account-login", ee), e("offset-address", te), e("offset-appointment", pe), e("offset-cart", de), e("offset-cart-count", me), e("offset-cart-type", Qe), e("offset-checkout", H), e("offset-event-checkout", De), e("offset-checkout-payment", he), e("offset-club-button", ye), e("offset-clubs", be), e("offset-continue-to-checkout", Se), e("offset-join-list", ge), e("offset-login-form", ke), e("offset-phone", _e), e("offset-product-buy-button", ve), e("offset-product-details", Ce), e("offset-product-list", Ue), e("offset-product-list-search", Fe), e("offset-product-list-sort", Pe), e("offset-product-list-options", Le), e("offset-product-list-filter", Ke), e("offset-side-cart", xe), e("offset-stripe-payment-form", Oe), e("offset-subscribe-form", Ae), e("offset-welcome", $e);
}
export {
  Z as Account,
  ee as AccountLogin,
  te as Address,
  pe as Appointment,
  de as Cart,
  me as CartCount,
  Qe as CartType,
  oe as Categories,
  H as Checkout,
  he as CheckoutPayment,
  ye as ClubButton,
  be as Clubs,
  Se as ContinueToCheckout,
  De as EventCheckout,
  Ve as Form,
  fe as GiftCardCheckout,
  ge as JoinList,
  ke as LoginForm,
  ue as Offering,
  _e as Phone,
  ve as ProductBuyButton,
  Ce as ProductDetails,
  Ue as ProductList,
  Ke as ProductListFilter,
  Le as ProductListOptions,
  Fe as ProductListSearch,
  Pe as ProductListSort,
  xe as SideCart,
  Oe as StripePaymentForm,
  Ae as SubscribeForm,
  $e as Welcome,
  At as defineElements
};
